<template>
    <div class="checkout relative">
    <VivaLoader />
    <HeaderDashboard />
        <main class="checkout-component bg-gray-50 pt-16 md:pt-36 pb-10">
            <div class="mx-auto flex flex-col md:flex-row max-w-7xl mx-auto container">
                <DashboardSidebarMenu isPage="perfil" class=" md:block"/>
                <div class="main-content w-full md:w-4/5 flex flex-col">
                    <section class="mb-5">
                        <div class="max-w-6xl mx-auto px-4">
                        <DashboardUserCardInformation />
                        </div>
                    </section>
                    <section class="mb-6">
                        <div class="max-w-6xl mx-auto px-4">
                            <div class="box px-5 sm:px-10 pt-10 pb-4 w-full">
                                <div class="flex flex-row content-center items-center mb-5">
                                    <h4 class="m-0 text-lg md:text-xl text-green-500 font-bold">{{thankyouTranslate[language].slides.enjoy}}</h4>
                                </div>
                                <div class=" pb-5 w-full flex flex-row flex-wrap md:flex-row justify-start items-start md:items-start md:mb-0">
                                    <div class="w-full lg:w-1/2 flex flex-row justify-start items-start content-center mb-10">
                                        <div class="pr-5 w-2/6 md:w-1/6">
                                            <img class="w-28" src="@/assets/img/membresia/pase-400.svg" alt="">
                                        </div>
                                        <div class="w-4/6 md:w-5/6">
                                            <h3 class="font-semibold text-green-500 text-lg">{{dashboardTranslate[language].perfil.exclusive.title}}</h3>
                                            <p class="text-base text-gray-800">{{dashboardTranslate[language].perfil.exclusive.subtitle}}</p>
                                        </div>
                                    </div>
                                    <div class="w-full lg:w-1/2 flex flex-row justify-start items-start content-center mb-10">
                                        <div class="pr-5 w-2/6 md:w-1/6">
                                            <img class="w-28" src="@/assets/img/membresia/coin-400.svg" alt="">
                                        </div>
                                        <div class="w-4/6 md:w-5/6">
                                            <h3 class="font-semibold text-green-500 text-lg">{{dashboardTranslate[language].perfil.special.title}}</h3>
                                            <p class="text-base text-gray-800">{{dashboardTranslate[language].perfil.special.subtitle}}</p>
                                        </div>
                                    </div>
                                    <div class="w-full lg:w-1/2 flex flex-row justify-start items-start content-center mb-10 lg:mb-0">
                                        <div class="pr-5 w-2/6 md:w-1/6">
                                            <img class="w-full" src="@/assets/img/membresia/equipaje-400.svg" alt="">
                                        </div>
                                        <div class="w-4/6 md:w-5/6">
                                            <h3 class="font-semibold text-green-500 text-lg">{{dashboardTranslate[language].perfil.baggage.title}}</h3>
                                            <p class="text-base text-gray-800">{{dashboardTranslate[language].perfil.baggage.subtitle}}</p>
                                        </div>
                                    </div>
                                     <div class="w-full lg:w-1/2 flex flex-row justify-start items-start content-center mb-5 lg:mb-0">
                                        <div class="pr-5 w-2/6 md:w-1/6">
                                            <img class="w-full" src="@/assets/img/membresia/logo-smile-fly-c.svg" alt="">
                                        </div>
                                        <div class="w-4/6 md:w-5/6 relative">
                                            <h3 class="font-semibold text-green-500 text-lg">{{dashboardTranslate[language].perfil.facial.title}}</h3>
                                            <p class="text-base text-gray-800">{{dashboardTranslate[language].perfil.facial.subtitle}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section class="mb-14">
                        <div class="max-w-6xl mx-auto px-4">
                            <div class="box sm:px-10 py-10 w-full">
                                <div class="max-w-4xl flex flex-row flex-wrap md:flex-row justify-center items-center md:items-center md:mb-0">
                                    <div class="w-full flex flex-row justify-center items-start content-center">
                                        <div class="pr-5 w-2/6 md:w-2/6 flex justify-center items-center content-center">
                                            <img class="w-40" src="@/assets/img/dashboard/face-id-scanv.svg" alt="">
                                        </div>
                                        <div class="w-4/6 md:w-4/6">
                                            <div class="flex mb-2">
                                                <h3 class="m-0 text-lg md:text-xl text-green-500 font-bold">
                                                    {{dashboardTranslate[language].facial.title }}
                                                </h3>
                                                <div class="ml-2 mt-3">
                                                    <img src="@/assets/img/dashboard/logo-smile-fly-a.svg" alt="">
                                                </div>
                                            </div>
                                            <p class="text-sm text-gray-800">
                                                    {{dashboardTranslate[language].facial.subtitle }}
                                            </p>
                                            <div class="mt-5">
                                                <a href="https://www.vivaaerobus.com/es-mx/profile/smile-and-fly" target="_blank" @click.prevent="goToLinkRegister( 'https://www.vivaaerobus.com/es-mx/profile/smile-and-fly', 'spid enrollment' )" class="flex text-sm font-semibold text-green-500 hover:underline">
                                                    <span class="mr-1">{{dashboardTranslate[language].facial.linkText }}</span>
                                                    <span><svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" /></svg></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="mb-0" >
                        <div class="max-w-6xl mx-auto px-4">
                            <h2 class="section-header text-3xl text-green-300 font-semibold md:font-bold mb-5">{{dashboardTranslate[language].promotions.headerTitle }}</h2>
                            <div class="flex flex-col lg:flex-row justify-between w-full lg:space-x-6">

                                <div class="box w-full lg:w-1/2 flex flex-col justify-between px-6 pt-6 mb-5 lg:mb-0">
                                    <div class="pb-5 lg:pb-0">
                                        <h3 class="font-semibold text-green-500 text-2xl mb-4">{{dashboardTranslate[language].promotionsBest.title }} </h3>
                                        <p class="text-md">{{dashboardTranslate[language].promotionsBest.subtitle }}</p>
                                    </div>
                                    <div class="border-t py-3 text-right">
                                        <a href="https://www.vivaaerobus.com/es-mx/promociones" @click.prevent="goToLink( 'https://www.vivaaerobus.com/es-mx/promociones', '2022 Viajero' )" target="_blank" class="flex justify-end items-center content-center text-lg font-semibold text-green-400 hover:text-green-500">
                                             <span class="mr-2 hover:underline">{{dashboardTranslate[language].promotionsBest.see }}</span>
                                             <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="my-5">
                        <div class="text-center p-10">
                            <div>{{dashboardTranslate[language].information.text }} </div>
                            <div><a :href="`mailto:${dashboardTranslate[language].information.email}`" class="text-green-400 font-semibold">{{dashboardTranslate[language].information.email }} </a></div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    <FooterCheckout />
    </div>
</template>

<script>
    import HeaderDashboard from "@/components/header/Header.vue"
    import FooterCheckout from "@/components/Footer.vue"
    import DashboardSidebarMenu from "@/components/dashboard/SidebarMenu.vue"
    import VivaLoader from "@/components/loader/Loader.vue"
    import DashboardUserCardInformation from '@/components/dashboard/UserCardInformation.vue'
    import { dashboardTranslate } from '@/translations/Dashboard.js'
    import { thankyouTranslate } from  '@/translations/ThankYou.js'
    import { computed, ref } from "@vue/reactivity"
    import { useStore } from "vuex"
    import { onMounted } from "@vue/runtime-core"
    import { dataLayerViewCard, dataLayerSharePromotion, dataLayerClickCard, dataLayerViewProfile} from '@/pixels/datalayer.js'

import { useRouter } from "vue-router"

    export default ({
        name: 'Perfil',
        components: {
            HeaderDashboard,
            FooterCheckout,
            DashboardSidebarMenu,
            VivaLoader,
            DashboardUserCardInformation
        },
        setup(){
            const store = useStore()
            const router = useRouter()
            const referralCode = ref('')
            const referralURL = ref('https://www.vivaaerobus.com/vivafan/subscription?rc=')
            const referralURLTemp = ref('/vivafan/subscription?rc=')
            const isCoppied = ref( false)

            const account = computed( () =>{
                return store.state.Accounts.data
            })
            
            const language = computed( ()=> {
                return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
            })

            const subscription = computed( () =>{
                return store.state.Checkout.data.userSubscription
            })

            const currency = computed(() => {
                return  localStorage.getItem('viva-currency') ? localStorage.getItem('viva-currency') : 'MXN';
            })

            const getCustomerId = () => {
                if( Object.keys(account.value).length != 0 ){
                    let acc = account.value.ids.find(({type}) => { return type == 'CustomerNumber' } )
                     return  acc.id 
                }
            }
            const copyRefURL = () =>  {
                const link = referralURL.value
                isCoppied.value = true
                setTimeout( () => {
                    isCoppied.value = !isCoppied.value
                }, 2000 )
                navigator.clipboard.writeText(link).then(function() {
                    console.log('Copying to clipboard was successful!');
                }, function(err) {
                    console.error('Could not copy text: ', err);
                });

                dataLayerSharePromotion()
            }
            const hasReferralCode =ref( false )
            const getReferralCode = () => {
                const code = store.state.Checkout.data.userSubscription.data.subscription.referralCode
                console.log( code )
                referralURL.value += code
                referralURLTemp.value += code

                referralCode.value = code
                if( code ){
                    hasReferralCode.value = true
                }
                
            }

            const checkSubscription = () =>{
                if( !subscription.value ){
                    router.push({name: 'Home'})
                }
            }

            const goToLink = ( url, type ) => {
                 window.open(url, '_blank').focus();
                 dataLayerViewProfile( type )

            }

            const goToLinkRegister = ( url, type ) => {
                 window.open(url, '_blank').focus();
                 dataLayerClickCard( type )

            }

            const initDataLayerCardView = () => {
                dataLayerViewCard( 'viva benefits' )
                dataLayerViewCard( 'facial recognition' )
                dataLayerViewCard( 'referal' ) 
                dataLayerViewCard( 'referal promotions' )
            }

            onMounted( async ()=> {
                if( Object.keys(store.state.Accounts.data).length == 0 ){
                    await store.dispatch('checkAccount')
                }

                if( Object.keys(subscription.value).length == 0 ){
                    await store.dispatch('getSubscription', { plan: 'vfn'})
                    await getReferralCode()
                    checkSubscription()
                } else {
                    await getReferralCode()
                }

                initDataLayerCardView()

            })

            return { copyRefURL, referralURL, referralURLTemp,  currency, dashboardTranslate, account, getCustomerId, language, isCoppied, subscription, goToLink, goToLinkRegister, thankyouTranslate, referralCode, hasReferralCode }
        },
    
    })
</script>

<style scoped>
.box {
    @apply bg-white border border-gray-200 shadow rounded-lg text-left rounded-lg shadow overflow-hidden;
}
h5 {
    @apply md:text-sm text-green-400;
    font-size: 0.75rem;
}
input.form-control, select.form-control{
    @apply font-semibold text-left focus:ring-green-400 focus:border-green-400 block w-full text-18 border-gray-300 rounded-md pt-7 pb-2 px-4 rounded-xl shadow-sm border text-green-500 outline-none;
}
label > span {
    @apply text-green-500 sm:text-xs;
}
.form-check-radio {
    @apply w-5 h-5 border-2 rounded-full bg-blue-100;
}
.form-radio-wrapper {
    @apply flex content-center items-center pt-5 pb-0 md:py-5 w-full md:w-auto;
}
.disabled {
    @apply opacity-50 cursor-not-allowed
}

.fade-enter-from {
    opacity: 0;
    height: 0;
}
.fade-enter-to {
    opacity: 1;
    height: auto;
}
.fade-enter-active {
   transition: all 300ms ease-out;
}
.fade-leave-from {
    opacity: 1;
    height: auto;
}
.fade-leave-to {
    opacity: 0;
    height: 0;
}
.fade-leave-active {
   transition: all 300ms ease-out;
}
</style>